import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=6e5e9e1c&"
import script from "./ChatContent.vue?vue&type=script&lang=js&"
export * from "./ChatContent.vue?vue&type=script&lang=js&"
import style0 from "./ChatContent.vue?vue&type=style&index=0&id=6e5e9e1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports